import './Business.less';

export const prefix = 'oc-c-business';

export { default } from './Business';